<template>
  <div>
    <GateNavbar />
    <GateSidebar />
    <div class="gate-main flex flex-col justify-between">
      <main>
        <slot />
      </main>
      <ThePageFooter />
    </div>
  </div>
</template>

<script setup>
import GateNavbar from '@/components/Navbar/GateNavbar.vue'
import GateSidebar from '@/components/Sidebar/GateSidebar.vue'
import ThePageFooter from '@/components/PageComponents/ThePageFooter.vue'

/** Кабинет — раскладка Novator (frontend-js `MainLayout`): панель сверху, меню слева. */
</script>

<style lang="scss">
.gate-main {
  margin-top: 56px;
  margin-left: 263px;
  min-height: calc(100vh - 56px);
  min-height: calc(100dvh - 56px);
}

// На телефоне меню не помещается сбоку — становится полосой вкладок под панелью.
@media (max-width: 600px) {
  .gate-sidebar.sidebar {
    position: sticky;
    top: 56px;
    // В потоке вкладки начинаются под фиксированной панелью — иначе контент уехал бы под них.
    margin-top: 56px;
    width: 100%;
    height: auto;
    z-index: 20;

    .sidebar_body {
      display: flex;
      gap: 4px;
      height: auto;
      padding: 8px;
      overflow-x: auto;
      scrollbar-width: none;
    }

    .sidebar_item {
      width: auto;
      margin-bottom: 0;
    }
  }

  .gate-main {
    margin-left: 0;
    margin-top: 0;

    main {
      padding: 12px;
    }
  }

  // Кнопки действий в шапке страницы — столбиком во всю ширину, а не лесенкой.
  .gate-actions {
    width: 100%;

    .el-button {
      flex: 1 1 100%;
      margin-left: 0;
    }
  }
}
</style>
